import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useFriendRequests(id, params = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchFriendRequests() {
      setLoading(true);
      const { response, data } = await API.fetchFriendRequests(token, id, params);

      if (response.ok) {
        setResult(data);
        setLoading(false);
        setError(null);
      } else {
        setError({ status: response.status, ...data });
        setLoading(false);
      }
    }

    fetchFriendRequests();
  }, [id, Object.values(params).join("__"), setResult, setLoading, setError]);

  return {
    loading,
    error,
    requests: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
